// ADR 16.9.26r §4 — the dock's one event. Moved out of `features/tutor/telemetry.ts`
// by ADR 25.9.26f §3: `TutorDockProvider` wraps the whole frame, so it is on
// the boot graph, and that module imports the wasm facade for `tutorSilentPair`.
// This one takes `TutorScreen` by `import type`, which the compiler erases.

import type { TutorScreen } from '../../../wasm'
import type { SurfaceHost } from '../../companion/hosts'

/**
 * `web_tutor_dock_toggled`, one per dock transition, `hello` and `bye`
 * included. `web_`-prefixed under 9.9.26m's rule for a web-only event;
 * `surface` is the route's `TutorScreen`. No `plan_id`, no content.
 * ADR 7.10.26w §6 — `host` is where the dock is (or would be) drawn under the
 * current layout, whatever the new state, so one breakdown reads three clients.
 */
export const DOCK_TOGGLED_EVENT = 'web_tutor_dock_toggled'

export type DockTransition = 'open' | 'closed' | 'detached'

export function dockToggledProps(state: DockTransition, surface: TutorScreen, host: SurfaceHost): Record<string, unknown> {
  return { state, surface, host }
}

/**
 * ADR 30.9.26k §4 — `web_tutor_dock_resized`, once per gesture: a drag, a held
 * arrow key and a double-click are one event each, never one per move. `size`
 * is the committed value rounded to a whole rem (column) or percent (sheet).
 */
export const DOCK_RESIZED_EVENT = 'web_tutor_dock_resized'

export type DockResizeInput = 'pointer' | 'keyboard' | 'reset'

export function dockResizedProps(
  orientation: 'column' | 'sheet',
  size: number,
  input: DockResizeInput,
  surface: TutorScreen,
): Record<string, unknown> {
  return { orientation, size: Math.round(size), input, surface }
}
